export const SUBJECTS_FEEDBACK = {
  LIST: {
    id: 1,
    name: "RealEstateList",
    title: "Lista de propiedades"
  },
  DETAIL: {
    id: 2,
    name: "RealEstateDetail",
    title: "Detalle de propiedades"
  },
  CREATE: {
    id: 3,
    name: "RealEstateCreate",
    title: "Creación de propiedades"
  },
  UPDATE: {
    id: 4,
    name: "RealEstateUpdate",
    title: "Actualización de propiedades"
  },
  PROJECT_CREATE: {
    id: 5,
    name: "ProjectCreate",
    title: "Creación de proyectos"
  }
};
